<template>
    <div class="season_detail"  v-if="!!selected_season">
        <nav class="top-navbar">
            <div class="back">
                <router-link to="/seasons">
                <img src="../../assets/images/chevron-left.svg"/>
                </router-link>
            </div>
            <div class="title">
                <div class="title-inner">
                <span class="title-inner-name">{{selected_season.name}}</span>
                </div>
            </div>
            <div class="icon-right">
                <router-link :to="'/seasons/' + selected_season.id + '/edit'"  class="btn-accept bordered-icon" v-if="$hisport.permissions.isAdmin()">
                    <font-awesome-icon :icon="['fas','edit']"/>
                </router-link>
                <a href="javascript: void 0" class="btn-red bordered-icon" v-if="$hisport.permissions.isAdmin()"
                 @click.stop.prevent="$hisport.todo('Who has permission to remove seasons?')">
                    <font-awesome-icon :icon="['fas','trash-alt']"/>
                </a>
            </div>
        </nav>
        <div class="season-qf hg-quick-form">
            <div class="qf-item">
                <div class="qf-title" v-i18n="'QF_SPORT'"></div>
                <div class="qf-body" v-i18n="$hisport.getSportName(selected_season.id_sport)"></div>
            </div>
            <div class="qf-item">
                <div class="qf-title" v-i18n="'QF_START_TS'"></div>
                <div class="qf-body">{{selected_season.start_at | moment('DD MMMM YYYY')}}</div>
            </div>
            <div class="qf-item">
                <div class="qf-title" v-i18n="'QF_END_TS'"></div>
                <div class="qf-body">{{selected_season.end_at | moment('DD MMMM YYYY')}}</div>
            </div>
        </div>
        <div class="event-list-wrapper">
            <event-list :events="selected_season.events" />
        </div>
    </div>
</template>
<script>
import eventList from "../_components/event_list"
export default {
    title(){
        if(this.selected_season) return this.selected_season.name;
        return "LOADING_SEASON";
    },
    components:{
        eventList
    },
    mounted(){
        var self = this;
        this.$hisport.datacontext.season.getById(this.$route.params.id)
        .then(function(season){
            self.selected_season = season;
        });
    },
    data(){
        return {
            selected_season: null,
        }
    },
    methods:{
        deleteSeason(){
        var self = this;
        this.$hisport.datacontext.season.remove(this.$route.params.id)
            .then(function(){
            self.$router.push("/seasons");
            })
        }
    }
}
</script>
<style scoped>
.event-list-wrapper{
  padding:30px;
}
</style>